import {Component, ComponentRef, Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {StandardDialogComponent} from '../models/standardDialog/standardDialog.components';
import {OptionsDialogComponent} from '../models/optionsDialog/optionsDialog.components';
import {SperrDialogComponent} from '../models/sperrDialog/sperrDialog.components';
import {environment} from '../../../../environments/environment';

@Injectable()
export class DialogVerwaltungsService {

  constructor(
    private dialog: MatDialog,
  ) {}

  public standardDialog(title, content, data){
    return this.dialog.open(StandardDialogComponent, {
      data:{
        title: title,
        content: content,
        data: data
      },
      disableClose: true,
      panelClass: environment.type == 'web'? 'dialogWbpMuster' : 'dialogWbaMuster'
    })
  }

  public optionsDialog(title: string, content, buttons, data){
    return this.dialog.open(OptionsDialogComponent, {
      data:{
        title: title,
        content: content,
        buttons: buttons,
        data: data
      },
      disableClose: true,
      panelClass: environment.type == 'web'? 'dialogWbpMuster' : 'dialogWbaMuster'
    })
  }

  public sperrDialog(title, content){
    this.dialog.open(SperrDialogComponent, {
      data:{
        title: title,
        content: content
      },
      disableClose: true,
      panelClass: environment.type == 'web'? 'dialogWbpMuster' : 'dialogWbaMuster'
    })
  }
  // panelClass: 'wartungsAbgleichDialog'
}

